import {CommonTitlesConstant} from '@core/constants/common-titles.constant';

export const ProfileStatsConstant = [
    {
        header_text: 'Total Events',
        stat: 0,
        image: 'assets/images/host-location-images/user-group-line.png'
    },
    {
        header_text: CommonTitlesConstant.total_players_number,
        stat: 0,
        image: 'assets/images/host-location-images/user-group.png'
    },
    {
        header_text: CommonTitlesConstant.avg_players_number,
        stat: 0,
        image: 'assets/images/host-location-images/user.png'
    },
    {
        header_text: 'Upcoming Events',
        stat: 0,
        image: 'assets/images/host-location-images/upcoming.png'
    },
    {
        header_text: 'Completed Events',
        stat: 0,
        image: 'assets/images/host-location-images/completed.png'
    }
];
